import {isLocked409, parseBlobError} from 'data/errors';

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Exports a project: creates a version of it, downloads that version and saves the file.
 *
 * `createVersion(projectId)` is tried twice at most: a 409 `project_locked` (the project is busy) is retried once after 1 s. Nothing
 * is left behind by the first attempt: the API rolls the row back (F8 6 D5 check 1). The download is never retried.
 * Any error is awaited through `parseBlobError`, so a text or JSON body inside a Blob is readable, and rethrown for the caller's one toast.
 *
 * @param {object} options
 * @param {string} options.projectId
 * @param {string} options.fileName the complete file name to save as, with the extension
 * @param {function(string): Promise<object>} options.createVersion resolves with the response whose `data.id` is the version's id
 * @param {function(object): Promise<Blob>} options.download gets the file of that version
 * @param {function(Blob, string)} options.save
 * @param {function(number): Promise} [options.sleep]
 */
export const runExport = async ({projectId, fileName, createVersion, download, save, sleep = wait}) => {
    try {
        let projectVersion;
        try {
            projectVersion = await createVersion(projectId);
        } catch (error) {
            if (!isLocked409(error)) throw error;
            await sleep(1000);
            projectVersion = await createVersion(projectId);
        }
        const file = await download(projectVersion);
        save(file, fileName);
    } catch (error) {
        await parseBlobError(error);
        throw error;
    }
};
